import * as angular from 'angular';

import { Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { Subject } from 'rxjs';

@Injectable()
export class ObservableService {
	constructor(@Optional() @SkipSelf() previousInstance?: ObservableService ) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
	}

	// Permet a un code angular-js d'obtenir un nouvel observable de commande pour interat
	public getNewSubject(): Subject<any> {
		return new Subject<any>();
	}
}

angular
	.module('auroraApp')
	.service('observableService', downgradeInjectable(ObservableService));